import { render, staticRenderFns } from "./PortfolioStatementsAndBrokerageNotes.vue?vue&type=template&id=164ee45f&scoped=true"
import script from "./PortfolioStatementsAndBrokerageNotes.vue?vue&type=script&setup=true&lang=ts"
export * from "./PortfolioStatementsAndBrokerageNotes.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PortfolioStatementsAndBrokerageNotes.vue?vue&type=style&index=0&id=164ee45f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164ee45f",
  null
  
)

export default component.exports